import Field from "mson/lib/fields/field";
import compiler from "mson/lib/compiler";

export default class CurrentForm extends Field {
  _className = "CurrentForm";

  _create(props: any) {
    super._create(props);

    this.set({
      schema: {
        component: "Form",
        fields: [
          {
            name: "required",
          },
        ],
      },
    });
  }

  validate() {
    super.validate();
  }

  getDisplayValue() {
    return "";
  }

  _setRequired(/* required */) {
    // Do nothing as we don't want to report any errors as this prop doesn't apply
  }
}

compiler.registerComponent("CurrentForm", CurrentForm);
